import { zip } from 'lodash';

const AppProtos = [
	'html5-f2b-enterprise',
	'html5-f2bcleverkids',
	'html5-f2bcleverkidsorange',
	'html5-f2b-myf2b',
].map(p => `${p}:`);
const WebProtos = ['http', 'https'].map(p => `${p}:`)
const Domains = [
	'myf2b.com',
	'myf2b.net',
	'footsteps2brilliance.com',
].map(d => d.split('.'));

const compArrays = (arr1, arr2) => zip(arr1, arr2).reduce((sameSoFar, [a, b]) => (sameSoFar && a === b), true);

const isTrustworthy = (urlStr) => {
	try {
		const url = new URL(urlStr);
		if(url.username || url.password){ return false; }
		if(AppProtos.includes(url.protocol)){ return true; }
		if(WebProtos.includes(url.protocol)){
			const splitted_host = url.host.split('.');
			return Domains.some((domain) => compArrays(domain, splitted_host.slice(-domain.length)));
		}
	}
	catch(e) {
		console.warn(e);
	}
	return false;
}
export default isTrustworthy;
